import React, { useState } from "react";
import "../styles/main.css";
import { Icon } from "../styles/icons.js";
import { RECORD_STATUS } from '../config/fieldsConfig.js';


export default function DataTable({
  title,
  data,
  fields,
  onView,
  onStateChange,
  onEdit,
  onDelete
}) {
  const visibleFields = fields.filter((f) => f.showInTable);

  const [sortField, setSortField] = useState(null);
  const [sortAsc, setSortAsc] = useState(true);
  const [filters, setFilters] = useState({ recordStatus: `!${RECORD_STATUS.SNOOZED}` });

  const handleSort = (fieldName) => {
    if (sortField === fieldName) {
      setSortAsc(!sortAsc);
    } else {
      setSortField(fieldName);
      setSortAsc(true);
    }
  };

  const handleFilterChange = (fieldName, value) => {
    setFilters((prev) => ({ ...prev, [fieldName]: value }));
  };

  const filteredData = data.filter((record) =>
    visibleFields.every((field) => {
      const filter = filters[field.name]?.toLowerCase() ?? "";
      const value = record[field.name]?.toString().toLowerCase() ?? "";
      //return value.includes(filter);
      return filter.startsWith("!") ? !value.includes( filter.slice(1) ) : value.includes(filter) ;
    })
  );

  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortField) return 0;
    const aVal = a[sortField]?.toString().toLowerCase() ?? "";
    const bVal = b[sortField]?.toString().toLowerCase() ?? "";
    return sortAsc ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
  });

  function getStatusChangeTitle( record ) {
    return( record.recordStatus === RECORD_STATUS.ACTIVE ? "Snooze" : "Activate" )
  }

  function getStatusChangeIcon( record ) {
    return( Icon( record.recordStatus === RECORD_STATUS.ACTIVE ? "snoozeRecord" : "activateRecord" ) )
  }

  return (
    <div className="tab-container">
      {title && <h2>{title}</h2>}
      <table className="data-table">
        <thead>
          <tr>
            {visibleFields.map((field) => (
              <th key={field.name} onClick={() => handleSort(field.name)}>
                {field.label || field.name}
                {sortField === field.name ? (sortAsc ? " ▲" : " ▼") : ""}
              </th>
            ))}
            {(onView || onEdit || onDelete) && <th>Actions</th>}
          </tr>
          <tr>
            {visibleFields.map((field) => (
              <th key={`filter-${field.name}`}>
                <input
                  type="text"
                  value={filters[field.name] || ""}
                  onChange={(e) =>
                    handleFilterChange(field.name, e.target.value)
                  }
                  placeholder="Filter"
                />
              </th>
            ))}
            {(onView || onEdit || onDelete || onStateChange ) && <th></th>}
          </tr>
        </thead>
        <tbody>
          {sortedData.length === 0 ? (
            <tr>
              <td colSpan={visibleFields.length + 1} style={{ textAlign: "center" }}>
                No records found
              </td>
            </tr>
          ) : (
            sortedData.map((record, index) => (
              <tr
                key={index}
                onClick={()=>onView && onView(record)}
                style={{ cursor: "pointer" }}
              >
                {visibleFields.map((field) => (
                  <td key={field.name}>
                    {record[field.name]?.toString() ?? ""}
                  </td>
                ))}
                {(onView || onEdit || onDelete || onStateChange ) && (
                  <td onClick={(e) => e.stopPropagation()}> {/*Stop Propagation here */}
                    { onView &&
                      <button className="icon-button"
                              title="View"
                              onClick={() => onView(record)} > {Icon("viewRecord")}
                      </button>
                    }
                    { onStateChange &&
                      <button className="icon-button"
                              title={getStatusChangeTitle(record)}
                              onClick={() => onStateChange(record)} > {getStatusChangeIcon(record)}
                      </button>
                    }
                    { onEdit &&
                      <button className="icon-button"
                              title="Edit"
                              onClick={() => onEdit(record)} > {Icon("updateRecord")}
                      </button>
                    }
                    { onDelete &&
                      <button className="icon-button"
                              title="Delete"
                              onClick={() => onDelete(record)} > {Icon("deleteRecord")}
                      </button>
                    }
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

